App.controller('HealthInsuranceWithPaymentsVisitCtrl', ['$scope', '$sce', '$state', '$http', 'packageService', '$stateParams', function ($scope, $sce, $state, $http, packageService, $stateParams) {
    $scope.stateParams = $stateParams;

    $scope.page = 'healthInsuranceWithPayments_visit';
    $scope.$emit('page', $scope.page);

    $scope.step = 'Umawianie wizyt';
    $scope.$emit('step', $scope.step);

    $scope.link = 'root.healthInsuranceWithPayments.start';
    $scope.$emit('link', $scope.link);
}]);
